import { Injectable, inject } from '@angular/core';
import { RegistrationBizDataModel, RegistrationDataModel } from '../../_interfaces/registration_response.interface';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BaseApiService } from '@bo/ng-api';
import { environment } from '../../../environments/environment';
import {
  VerifyAccountData,
  VerifyAccountResponse,
  ValidTokenResponse,
  ValidTokenData,
  DetailResponse,
} from '../../_interfaces/verify-account';
import { DirectorApproval, DirectorApprovalDetail } from '../../_interfaces/director-approval.interface';

@Injectable({
  providedIn: 'root',
})
export class RegisterService extends BaseApiService {
  protected override http: HttpClient;

  override baseUrl: string = environment.apiRoot;
  URL_SIGNUP: string = 'signup';
  URL_BUSINESS: string = 'business';
  URL_RESEND: string = 'resend';
  URL_VALID: string = 'valid';
  URL_VERIFY: string = 'verify';

  URL_VERIFY_PHONE: string = 'verify/phone';
  URL_BIZ_UPLOAD_CERT: string = 'biz/upload-cert';
  URL_DIRECTOR_APPROVAL_VALIDATION: string = 'director-approval/validate';
  URL_DIRECTOR_APPROVAL: string = 'director-approval/approve';
  URL_DIRECTOR_APPROVAL_RESEND: string = 'director-approval/resend';

  constructor() {
    const http = inject(HttpClient);

    super(http);

    this.http = http;
  }

  register(data: RegistrationDataModel): Observable<RegistrationDataModel> {
    return this.http.post<RegistrationDataModel>(this.getUrl(this.URL_SIGNUP, true), data);
  }

  register_biz(signupID: string, data: RegistrationBizDataModel): Observable<RegistrationBizDataModel> {
    const url = this.getUrl([this.URL_SIGNUP, signupID, this.URL_BUSINESS], true);
    return this.http.post<RegistrationBizDataModel>(url, data);
  }

  verifyAccount(signupID: string, data: VerifyAccountData) {
    const url = this.getUrl([this.URL_SIGNUP, signupID, this.URL_VERIFY], true);
    return this.http.post<VerifyAccountResponse>(url, data);
  }

  verifyAccountTokenValid(signupID: string, data: ValidTokenData) {
    const url = this.getUrl([this.URL_SIGNUP, signupID, this.URL_VALID], true);
    return this.http.post<ValidTokenResponse>(url, data);
  }

  resendEmail(signupID: string) {
    const url = this.getUrl([this.URL_SIGNUP, signupID, this.URL_RESEND], true);
    return this.http.post<VerifyAccountResponse>(url, {});
  }

  requestOTP(): Observable<DetailResponse> {
    return this.http.post<DetailResponse>(this.getUrl(this.URL_VERIFY_PHONE, true), {});
  }

  verifyPhone(code: string) {
    return this.http.put(this.getUrl(this.URL_VERIFY_PHONE, true), { code: code });
  }

  uploadBusinessCertificate(url: string) {
    return this.http.post(this.getUrl(this.URL_BIZ_UPLOAD_CERT, true), {
      file: url,
    });
  }

  directorApprovalValidation(data: DirectorApproval): Observable<DirectorApprovalDetail> {
    return this.http.post<DirectorApprovalDetail>(this.getUrl(this.URL_DIRECTOR_APPROVAL_VALIDATION, true), data);
  }

  directorApproval(data: DirectorApproval): Observable<DirectorApproval> {
    return this.http.post<DirectorApproval>(this.getUrl(this.URL_DIRECTOR_APPROVAL, true), data);
  }

  resendDirectorApproval() {
    return this.http.put(this.getUrl(this.URL_DIRECTOR_APPROVAL_RESEND, true), {});
  }
}
